module.exports = __webpack_public_path__ + "img/skin-01.3c4c0361.png";